import { lazy } from "react";
import { DashboardContextProvider, useAuthContext, CONFIG_KEYS } from ".";
const InsightsDashboard = lazy(() => import("./InsightsDashboard.jsx"));
const Insights = lazy(() => import("pages/Insights"));
// import InsightsDashboard from "./SmsDashboard.tsx";

const DashboardController = () => {
  const { globalConfigMap } = useAuthContext();
  const newDashboardEnabled = globalConfigMap.isEnabled(
    CONFIG_KEYS.newDashboardEnabled,
    true
  );

  console.log(`[INFO] New dashboard enabled: ${newDashboardEnabled}`);
  return (
    <DashboardContextProvider>
      <InsightsDashboard />
    </DashboardContextProvider>
  );
  // if (newDashboardEnabled) return <InsightsDashboard />;
  // else return <Insights />;
};

export default DashboardController;
